import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

// path globals
import { API_PATH, SUBSCRIPTION_KEY, SET_ABANDONMENT } from '../globals';

@Injectable({
  providedIn: 'root',
})
export class AbandonmentService {

  constructor (
    private _http: HttpClient
  ) {}

  setAbandonment(request: any, status: string) {
    try {

      const s = JSON.stringify(request);

      const jsonRequest: {jsonRequest: string, subscripionStatus: string} = {
        jsonRequest: btoa(s),
        subscripionStatus: status
      };

    // const headers = new HttpHeaders();
    // headers.append('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);
     const headers = new HttpHeaders()
    .set('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);

      this._http
        .post(API_PATH + SET_ABANDONMENT, jsonRequest, {headers:headers})
        .subscribe(
          res => {

        });
    } catch (err) {
      // console.log('error SetAbandonment');
    }
  }
}
